import { DialogContent, Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";

import { StickyScrollPageHeader } from "../redesign/components/StickyScrollPageHeader";

export function CancelRateNegotiationDialogContent() {
  return (
    <DialogContent sx={{ backgroundColor: "unset", py: 8, mt: 8 }}>
      <StickyScrollPageHeader title="Cancel Rate Negotiation?" headerVariant="tertiary" />
      <Stack alignItems="left" flex={1} gap={4}>
        <Text variant="body1" sx={{ textAlign: "center" }}>
          When you end a negotiation you won&apos;t be able to propose another rate for the same
          shift.
        </Text>
        <Text semibold variant="body1" sx={{ textAlign: "center" }}>
          Are you sure you want to end this shift rate negotiation?
        </Text>
      </Stack>
    </DialogContent>
  );
}
